module.exports = __webpack_public_path__ + "img/logo-mini-light@2x.a3e725c0.png";